import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const getAllMPTubeRoomTempTables = async (page, size, searchString) => {
    const response = await api.get(`/${ENDPOINTS.MP_TUBE_ROOM_TEMP}`, {
        params: { page, size, search: searchString },
    });

    return response.data;
};